import * as yup from "yup";
import { drillSchemaFields } from "../UploadActivity/schema";

export const uploadVideosFormSchemaFactory = (activityTypes?: ActivityType[]) =>
  yup.object().shape({
    activityType: yup.string(),
    hasConfirmed: yup.boolean().isTrue("Please confirm that the above statement is true"),
    ...drillSchemaFields(activityTypes),
  });
